import { render } from "./LinkField.vue?vue&type=template&id=3b050b16&scoped=true"
import script from "./LinkField.vue?vue&type=script&lang=js"
export * from "./LinkField.vue?vue&type=script&lang=js"

import "./LinkField.vue?vue&type=style&index=0&id=3b050b16&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b050b16"]])

export default __exports__